module.exports = __webpack_public_path__ + "img/ic02.ed8f1212.png";